var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicistNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 6.5C8.25 6.08579 8.58579 5.75 9 5.75H16.5C16.9142 5.75 17.25 6.08579 17.25 6.5C17.25 6.91421 16.9142 7.25 16.5 7.25H9C8.58579 7.25 8.25 6.91421 8.25 6.5ZM9 10.25H16.5C16.9142 10.25 17.25 9.91421 17.25 9.5C17.25 9.08579 16.9142 8.75 16.5 8.75H9C8.58579 8.75 8.25 9.08579 8.25 9.5C8.25 9.91421 8.58579 10.25 9 10.25ZM21.75 2V13.25C21.75 14.4926 20.7426 15.5 19.5 15.5H3C1.76138 15.5 0.755677 14.4989 0.75 13.2603V4.25C0.75 3.83579 1.08579 3.5 1.5 3.5C1.91421 3.5 2.25 3.83579 2.25 4.25V13.25C2.25 13.6642 2.58579 14 3 14C3.41421 14 3.75 13.6642 3.75 13.25V2C3.75 1.17157 4.42157 0.5 5.25 0.5H20.25C21.0784 0.5 21.75 1.17157 21.75 2ZM20.25 2H5.25V13.25C5.25037 13.5055 5.20693 13.7592 5.12156 14H19.5C19.9142 14 20.25 13.6642 20.25 13.25V2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicistNew);
export default __webpack_public_path__ + "static/media/publicist-new.b00b416a5399196fab35f71932f1b18c.svg";
export { ForwardRef as ReactComponent };